import { IPendingConnection, IConnectionBillingPreview } from '../interfaces';
import { IPendingBillingConnection } from '../interfaces/paymentMethods';

export const convertPending = (
  pendingConnections: IPendingConnection[],
  pendingConnectionsBillingPreview: IPendingBillingConnection[],
  activeConnectionsCount: number
): IConnectionBillingPreview[] => {
  if (!pendingConnections.length || !pendingConnectionsBillingPreview.length) {
    return [];
  }

  return [...pendingConnections]
    .sort(
      (connectionA, connectionB) =>
        new Date(connectionA.dateRequested).getTime() - new Date(connectionB.dateRequested).getTime()
    )
    .map((connection, index) => {
      const billingPreview = pendingConnectionsBillingPreview.find(
        item => item.organizationId === connection.organizationId
      );
      const ordinal = activeConnectionsCount + index + 1;

      return {
        organizationId: connection.organizationId,
        organizationName: connection.organizationName,
        type: connection.requestType,
        ordinal: ordinal,
        price: billingPreview?.price ?? 0,
        isPotentiallyFreeConnection: isPotentiallyFreeConnection(billingPreview),
        isFreeConnection: isFreeConnection(billingPreview),
        isPartiallyFreeConnection: isPartiallyFreeConnection(billingPreview),
        requested: false
      };
    });
};

export const isFreeConnection = (connection: IPendingBillingConnection | undefined | null): boolean => {
  if (!connection) {
    return false;
  }

  return (
    (connection.isCap && connection.price === 0) ||
    connection.isRollUp ||
    connection.isReconnect ||
    connection.price === 0
  );
};

export const isPotentiallyFreeConnection = (connection: IPendingBillingConnection | undefined | null): boolean => {
  if (!connection) {
    return false;
  }

  return !isFreeConnection(connection) && connection.isPotentialRollUp;
};

export const isPartiallyFreeConnection = (connection: IPendingBillingConnection | undefined | null): boolean => {
  if (!connection) {
    return false;
  }

  return connection.isCap && connection.price > 0;
};
